import Api from '../Utils/Axios';

export const GetDashboardCounters = async () => {
  const response = await Api.get('dashboard/counters/');
  return response.data;
};

export const GetPopularDiscovers = async () => {
  const response = await Api.get('dashboard/popularDiscovers/');
  return response.data;
};

export const GetDashboardRegisterUserChart = async (
  type,
  startDate,
  endDate
) => {
  let url = `dashboard/registerUsersChart?type=${type}`;
  if (startDate && endDate) {
    url += `&startDate=${startDate}&endDate=${endDate}`;
  }
  const response = await Api.get(url);
  return response.data;
};